import AppBreadcrumb from "./AppBreadcrumb.vue";

export default {
  extends: AppBreadcrumb
};
